import SectionHeader from '@components/ui/SectionHeader'
import styles from './styles.module.scss'
import IconCard, { IconCardProps } from './IconCard'

type ContentFulPageProps = {
  title: string
  cards: {
    [key: number]: IconCardProps
  }
  props: string
}

export default function IconCards(props: ContentFulPageProps) {
  const { title, cards } = props
  return (
    <div className={styles.IconCards}>
      <div className={styles.IconCards__wrapper}>
        <SectionHeader title={title} variant="left_aligned" />

        <div className={styles.IconCards__cards}>
          <div className={styles.IconCards__cardsWrapper}>
            {Object.values(cards).map((card, index) => (
              <IconCard {...card} key={`${card.title}-${index}`} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
